<template>
  <div class="error-page">
    <div class="reason">
      <h2>出了小狀況。</h2>
      <p>
        由於某些技術上的原因，您所要求的網頁發生錯誤，造成您的不便敬請見諒。
      </p>
      <p class="error-code">錯誤代碼:{{ $route.query.errorCode }}</p>
    </div>
    <!-- <v-btn dark block color="#1DA7FC" @click="backToHome()">
      返回首頁
    </v-btn> -->
  </div>
</template>

<script>
export default {
  name: 'Error',
  data() {
    return {}
  },
  methods: {
    backToHome() {
      if (localStorage.getItem('source') === 'e7g') {
        window.location = process.env.VUE_APP_E7G_HOME
      } else {
        this.$router.replace({ name: 'home' })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.error-page {
  padding: 16px;
  margin: auto;
}
</style>
